import type { CreateGroupAttributes, UpdateGroupAttributes } from 'common'
import { coreClient } from '@/api/coreclient'

export default {
  async index(organizationId: number) {
    const client = await coreClient()
    return client.group
      .index(organizationId)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async show(id: number) {
    const client = await coreClient()
    return client.group
      .show(id)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async create(organizationId: number, data: CreateGroupAttributes) {
    const client = await coreClient()
    return client.group
      .create(organizationId, data)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async createDefault(organizationId: number) {
    const client = await coreClient()
    return client.group
      .createDefault(organizationId)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async setDefault(id: number) {
    const client = await coreClient()
    return client.group
      .setDefault(id)
      .then((data) => data.data)
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async setExternal(id: number) {
    const client = await coreClient()
    return client.group
      .setExternal(id)
      .then((data) => data.data)
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async update(id: number, data: UpdateGroupAttributes) {
    const client = await coreClient()
    return client.group
      .update(id, data)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async delete(id: number) {
    const client = await coreClient()
    return client.group
      .delete(id)
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
